import { connect, MapStateToProps, MapDispatchToProps } from 'react-redux';
import { AppState } from '../../types/store';
import {
  getActiveSection,
  getPlaygroundSubsection,
} from '../../selectors/studio';
import { Props } from './StudioWrapper';
import { getIsVisitorView } from '../../selectors/stash';

export type StateProps = Pick<
  Props,
  'activeSection' | 'activePlaygroundSubsection' | 'isStashVisitorView'
>;
export type DispatchProps = Pick<Props, never>;
export type OwnProps = Omit<Props, keyof (StateProps & DispatchProps)>;

const mapStateToProps: MapStateToProps<
  StateProps,
  OwnProps,
  AppState
> = state => ({
  activeSection: getActiveSection(state),
  activePlaygroundSubsection: getPlaygroundSubsection(state),
  isStashVisitorView: getIsVisitorView(state),
});
const mapDispatchToProps: MapDispatchToProps<DispatchProps, OwnProps> = {};

export default connect(mapStateToProps, mapDispatchToProps);
